/* 注釈 */
import React from 'react';

interface Props {
  text: string;
}

const Annotation: React.FC<Props> = ({ text }) => {
  return <div className="p-lead my-3">{text}</div>;
};

export default Annotation;
